import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientName: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    category: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of people' }
      ]
    },
    sitename: {
      validations: []
    },
    siteaddress: {
      validations: []
    },
    sitecity: {
      validations: []
    },
    sitestate: {
      validations: []
    },
    sitepostal: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    theme: {
      validations: []
    },
    operation: {
      validations: []
    },
    description: {
      validations: []
    },
    comments: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'TELL US ABOUT YOUR NEXT PARTY!',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Company',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Company',
            mapping: 'clientName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'First Name',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'First Name',
            mapping: 'firstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Last Name',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Email',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Email',
            mapping: 'email',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Phone',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Phone',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Industry',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Industry',
            options: [
              { label: 'Full Service', value: 'Full Service' },
              { label: 'Drop Off', value: 'Drop Off' },
              { label: 'Pick Up', value: 'Pick Up' },
              { label: 'Event/Wedding Planner', value: 'Event/Wedding Planner' },
              { label: 'Marketing Retail', value: 'Marketing Retail' },
              { label: 'Not for Profit', value: 'Not for Profit' },
              { label: 'Production', value: 'Production' },
              { label: 'Promotion', value: 'Promotion' },
              { label: 'Social Non-Wedding', value: 'Social Non-Wedding' },
              { label: 'Social Wedding', value: 'Social Wedding' },
              { label: 'Vendor', value: 'Vendor' },
              { label: 'The Salon', value: 'The Salon' }
            ],
            mapping: 'category',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Guest Count',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Guest Count',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Venue',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Venue',
            options: [
              { label: 'Full Service', value: 'Full Service' },
              { label: 'Drop Off', value: 'Drop Off' },
              { label: 'Pick Up', value: 'Pick Up' },
              { label: 'The Salon', value: 'The Salon' }
            ],
            mapping: 'sitename',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Venue Address',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Venue Address',
            mapping: 'siteaddress',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Venue City/St/Zip',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Venue City',
            mapping: 'sitecity',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Venue State',
            mapping: 'sitestate',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Venue Zip',
            mapping: 'sitepostal',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'headerLabel'
          },
          {
            type: 'date-picker',
            size: 'Large',
            label: 'Event Date',
            mapping: 'eventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Start Time',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Start Time',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00' },
              { label: '10:30AM', value: '10:30:00' },
              { label: '11:00AM', value: '11:00:00' },
              { label: '11:30AM', value: '11:30:00' },
              { label: '12:00PM', value: '12:00:00' },
              { label: '12:30PM', value: '12:30:00' },
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00' }
            ],
            mapping: 'starttime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'End Time',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'End Time',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00' },
              { label: '10:30AM', value: '10:30:00' },
              { label: '11:00AM', value: '11:00:00' },
              { label: '11:30AM', value: '11:30:00' },
              { label: '12:00PM', value: '12:00:00' },
              { label: '12:30PM', value: '12:30:00' },
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00' }
            ],
            mapping: 'endtime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Catering Style',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Catering Style',
            options: [
              { label: 'Full Service', value: 'Full Service' },
              { label: 'Drop Off', value: 'Drop Off' },
              { label: 'Pick Up', value: 'Pick Up' },
              { label: 'The Salon', value: 'The Salon' },
              { label: 'Undecided', value: 'Undecided' }
            ],
            mapping: 'theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Style of Service',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Style of Service',
            options: [
              { label: 'Buffet', value: 'Buffet' },
              { label: 'Family Style', value: 'Family Style' },
              { label: 'Plated', value: 'Plated' },
              { label: 'Cocktail Party', value: 'Cocktail Party' },
              { label: 'Stations', value: 'Stations' }
            ],
            mapping: 'operation',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Occasion',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Occasion',
            options: [
              { label: 'Anniversary', value: 'Anniversary' },
              { label: 'Bar Mitzvah', value: 'Bar Mitzvah' },
              { label: 'Bat Mitzvah', value: 'Bat Mitzvah' },
              { label: 'Baby Shower', value: 'Baby Shower' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Brunch', value: 'Brunch' },
              { label: 'Business Event', value: 'Business Event' },
              { label: 'Cocktail party', value: 'Cocktail party' },
              { label: 'Conference', value: 'Conference' },
              { label: 'Convention', value: 'Convention' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Dinner Party', value: 'Dinner Party' },
              { label: 'Engagement', value: 'Engagement' },
              { label: 'Fundraiser', value:  'Fundraiser' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Grand opening', value: 'Grand opening' },
              { label: 'Holiday party', value: 'Holiday party' },
              { label: 'Housewarming', value: 'Housewarming' },
              { label: 'Lunch', value: 'Lunch' },
              { label: 'Meeting', value: 'Meeting' },
              { label: 'Memorial', value: 'Memorial' },
              { label: 'Office Meal', value: 'Office Meal' },
              { label: 'Party', value: 'Party' },
              { label: 'Passover', value: 'Passover' },
              { label: 'Photo/Film Shoot', value: 'Photo/Film Shoot' },
              { label: 'Premiere', value: 'Premiere' },
              { label: 'Reception', value: 'Reception' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Reunion', value: 'Reunion' },
              { label: 'Baby Shower', value: 'Baby Shower' },
              { label: 'Sporting Event', value: 'Sporting Event' },
              { label: 'Wedding Shower', value: 'Wedding Shower' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'description',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Dietary Restrictions',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Dietary Restrictions',
            mapping: 'comments',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'How did you hear about us?',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'How did you hear about us?',
            options: [
              { label: 'Emma', value: 'Emma' },
              { label: 'Employee Referral', value: 'Employee Referral' },
              { label: 'Event Attendee', value: 'Event Attendee' },
              { label: 'External referral', value: 'External referral' },
              { label: 'Other', value: 'Other' },
              { label: 'Phone', value: 'Phone' },
              { label: 'Repeat Client', value: 'Repeat Client' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Venue Referral', value: 'Venue Referral' },
              { label: 'Word of Mouth', value: 'Word of Mouth' },
              { label: 'Yolk and Flour', value: 'Yolk and Flour' }
            ],
            mapping: 'reference',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Additional Notes',
            mapping: 'headerLabel'
          },
          {
            type: 'text-area',
            size: 'Large',
            label: 'Additional Notes',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Heirloom LA Contact Us Form',
    formId: '171',
    clientKey: '3907878A-6653-415E-9760-522CD42AE1BE',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thanks for contacting us! We will get in touch with you shortly.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/heirloomla/form_structure.js